/**
 * @fileoverview GET handler for the "/app_settings/custom_attributes_tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsCustomAttributesTags } from "./constants";
import type { AppSettingsCustomAttributesTagsResult } from "./types";

export const getAppSettingsCustomAttributesTags = reactQueryFetcherAdapter(
  appSettingsCustomAttributesTags,
  (signal: AbortSignal): Promise<AppSettingsCustomAttributesTagsResult> => {
    return fetch("/app_settings/custom_attributes_tags", "GET", {}, { signal });
  }
);
